// @flow

import { selectPricingInfos } from '@gandi/billing';
import type { Grid, Currency } from '@gandi/billing';
import { selectMailboxesPrices } from '@gandi/redux-resource-price';
import type { MailboxPricesByType } from '@gandi/redux-resource-price';
import { selectCurrentId } from '@gandi/redux-sharing';

import { useAppSelector } from 'src/hooks/useAppSelector';

export default function useMailboxCatalog(): {
  currency: Currency,
  grid: Grid,
  prices: MailboxPricesByType,
  sharingId: string,
} {
  const sharingId = useAppSelector(selectCurrentId);

  const { currency, grid } = useAppSelector(selectPricingInfos);

  const prices = useAppSelector(state =>
    selectMailboxesPrices(state, {
      process: 'create',
      productType: 'mailboxv2',
      sharingId,
      currency,
      grid,
    }),
  );

  return {
    prices,
    currency,
    grid,
    sharingId,
  };
}
